import { Card, CardHeader } from "@mui/material";
import { BooleanInput } from "react-admin";
import { usePlanningItem } from "./hooks/usePlanningItem";
import { InitialData, PlanningConfig } from "./types";
import PlanningItemContent from "./components/PlanningItemContent";
import { getPlanningCardBackground } from "./utils/styles";

interface PlanningItemProps {
  config: PlanningConfig;
  index: number;
  initialData: InitialData;
}

const TestFcrRtePlanningItem = ({ config, index, initialData }: PlanningItemProps) => {
  const {
    currentActive,
    isOverlappingDays,
    isSocManagement,
    validateStartDate,
    validateEndDate,
    handleStartDateChange,
    handleEndDateChange,
    handleActiveToggle,
    prevPlanningValues,
    currentPlanning,
  } = usePlanningItem({ config, index, initialData });

  return (
    <Card
      variant="outlined"
      sx={{
        mb: 2,
        width: "100%",
        backgroundColor: getPlanningCardBackground(currentActive, isOverlappingDays),
      }}
    >
      <CardHeader
        title={config.name}
        subheader={`Durée par défaut: ${config.durationInMinutes} minutes`}
        action={
          <BooleanInput
            source={`${config.name}.active`}
            label="Actif"
            defaultValue={true}
            onChange={(e) => handleActiveToggle(e.target.checked)}
          />
        }
      />
      <PlanningItemContent
        config={config}
        currentActive={currentActive}
        isSocManagement={isSocManagement}
        isOverlappingDays={isOverlappingDays}
        validateStartDate={validateStartDate}
        validateEndDate={validateEndDate}
        handleStartDateChange={handleStartDateChange}
        handleEndDateChange={handleEndDateChange}
        currentPlanningStartDate={currentPlanning.start_date}
        prevPlanningEndDate={prevPlanningValues ? new Date(prevPlanningValues.end_date) : null}
      />
    </Card>
  );
};

export default TestFcrRtePlanningItem;
